export default {
      id: "icon-pdf-usage",
      viewBox: "0 0 39.55 45.865",
      url: __webpack_public_path__ + "icons.svg#icon-pdf",
      toString: function () {
        return this.url;
      }
    }